import {
  Component,
  OnDestroy,
  ChangeDetectorRef,
  EventEmitter,
  Inject
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Store, select } from '@ngrx/store';
import {
  BuyerState,
  RemoveSearchHistoryTerm,
  getCategories
} from '../../../store';
import get from 'lodash.get';

import { MmPopoverRef } from '~shared/modules/popover/popover.module';
import { HistoryTerm, Category } from '~app/modules/generic/models';
import * as fromHeader from '~app/modules/generic/store';
import { DOCUMENT } from '@angular/common';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
@Component({
  selector: 'app-header-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: [ './mobile-menu.component.scss' ],
})
export class MobileMenuComponent implements OnDestroy {
  categories$: Observable<Category[]>;
  menuStyles: { [key: string]: string | number };

  private headerHeight = this.document.getElementsByClassName('page-header')[0].clientHeight;
  private readonly destroySubject$ = new Subject();
  private closeEmitter: EventEmitter<null>;
  isSuggestionsListVisible$: Observable<boolean>;
  isHideTopLineMenu = false;

  constructor(
    private menuRef: MmPopoverRef,
    private changeDetector: ChangeDetectorRef,
    private store: Store<BuyerState>,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.closeEmitter = get(this.menuRef, [ 'data', 'closeEmitter' ]);
    const positionChanged$ = get(this.menuRef, [ 'data', 'positionChanged$' ]);
    positionChanged$
      ?.pipe(takeUntil((this.destroySubject$)))
      .subscribe(({ width, height }: { [key: string]: number }) => {
        this.menuStyles = { 'width.px': width, 'height.px': height - this.headerHeight };
        this.changeDetector.detectChanges();
      });
    this.isSuggestionsListVisible$ = this.store.pipe(select(fromHeader.isSearchSuggestionsListVisible));
    this.initializeCategories();
  }

  ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }

  promoClick() {
    this.closeEmitter.emit();
  }

  closeMenu() {
    this.closeEmitter.emit();
  }

  onHistoryRemoved(term: HistoryTerm) {
    this.store.dispatch(new RemoveSearchHistoryTerm(term));
  }

  hideTopLineMenu(value: boolean) {
    this.isHideTopLineMenu = value;
  }

  private initializeCategories(): void {
    this.categories$ = this.store.pipe(select(getCategories));
  }
}
